module.exports = __webpack_public_path__ + "static/img/code-of-life-2.acb967a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/code-of-life-2.jpg
// module id = h01P
// module chunks = 1